<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="queryArea">
    <div class="row queryInnerArea">
        <div class="col-md-3 topic-left-section">
            <div class="d-flex justify-content-start" style="margin: 1rem 1rem 2px 0px !important;">
                <img src="../../assets/img/chat-logo.png" height="32px;" alt="img">&nbsp;
                <label for="communication" style="color: #232323;font-size: 20px;">Communication</label>
            </div>
            <div class="row mail-title-panel">
                <div class="row tab" *ngIf="message.isTopicAdministrator" >
                    <div class="d-flex justify-content-center align-items-center">
                        <div class="col-md-8" >
                            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                                (click)="openCommunicationPopup('New')">
                                <img src="../../../assets/img/raise-topic.png" width="14px" height="14px"
                                    alt="add new" />
                                <span class="reload_text text-white" >Raise New Topic</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row tab" onselectstart="return false;">
                    <div class="col-md-6 addIconContiner reload_text text-white title-align "
                        [ngClass]="receivedSection ? 'ifReceivedSection':'sleep-mode'" (click)="displayReceivedMails()">
                        <span [ngClass]="receivedSection ? 'highlight-selection':''">Received</span>
                    </div>
                    <div class="col-md-6 addIconContiner reload_text text-white title-align"
                        [ngClass]="sentSection ? 'ifSentSection':'sleep-mode'" (click)="displaySentMails()">
                        <span [ngClass]="sentSection ? 'highlight-selection':''">Sent</span>
                    </div>
                </div>
            </div>

            <div class="row messageSection" [hidden]="!receivedSection">
                <div *ngFor="let receivedTopics of receivedTopicsList, let i=index;" class="message"
                    [ngClass]="i == highlight ? 'selected-message' : ''"
                    [ngStyle]="receivedTopics.readAlready == 'N'? {'border-left' : '4px solid #005C8A'} : {}"
                    (click)="openMessageContent(receivedTopics, i)"
                    (contextmenu)="onContextMenu($event, receivedTopics)">
                    <div>
                        <div class="row bold-messages">
                            <div class="col-md-2">
                                <img src="../../assets/img/Group.png" width="35px" height="35px" alt="user-img" />
                            </div>
                            <div class="col-md-5">
                                <div class="col-md-12">
                                    {{receivedTopics.createdByUser}}
                                </div>
                                <div class="col-md-12 subject-left-panel message-color"
                                    [ngClass]="receivedTopics.readAlready == 'N' ? 'unread-message-color' : ''">
                                    <span>{{receivedTopics.subject}}</span>
                                </div>
                            </div>
                            <div class="col-md-5" style="font-size: 10px; float: right">
                                <span>
                                    {{receivedTopics.createdOn | date: 'dd-MMM-yyyy HH:mm'}}</span>&nbsp;&nbsp;
                                <span *ngIf="receivedTopics.attachmentExists == 'Y'"><i
                                        class="fa fa-paperclip"></i></span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <span style="font-weight: 575; font-size: 12px; color: #cdb221;">
                            Initiated By:&nbsp;{{receivedTopics.createdByUser}}</span>
                        <span *ngIf="receivedTopics.status == 'Closed'" style="float: right; color: red;">
                            <span class="closed-text">Closed</span></span>
                    </div>
                    <div class="module-content-leftpanel" *ngIf="receivedTopics.moduleName">
                        <span>
                            {{receivedTopics.moduleName}}&nbsp;-&nbsp;{{receivedTopics.taskId}}&nbsp;-&nbsp;{{receivedTopics.taskName}}<span
                                *ngIf="receivedTopics.subTaskType">({{receivedTopics.subTaskType}})</span><span
                                *ngIf="receivedTopics.version">V:&nbsp;&nbsp;{{receivedTopics.version}}</span>
                        </span>
                    </div>
                </div>
                <div style="visibility: hidden; position: fixed;" [matMenuTriggerFor]="contextMenu"
                    [style.left]="menuTopLeftPosition.x" [style.top]="menuTopLeftPosition.y">
                </div>
            </div>
            <div class="row messageSection" *ngIf="sentSection">
                <div *ngFor="let sentTopics of sentTopicsList; let i = index;" class="message"
                    (click)="openMessageContent(sentTopics, i)">
                    <div>
                        <div class="row bold-messages">
                            <div class="col-md-2">
                                <img src="../../assets/img/Group.png" width="35px" height="35px" alt="user-img" />
                            </div>
                            <div class="col-md-5">
                                <div class="col-md-12">
                                    {{sentTopics.createdByUser}}
                                </div>
                                <div class="col-md-12 subject-left-panel message-color">
                                    <span>{{sentTopics.subject}}</span>
                                </div>
                            </div>
                            <div class="col-md-5" style="font-size: 10px; float: right">
                                <span>
                                    {{sentTopics.createdOn | date: 'dd-MMM-yyyy HH:mm'}}</span>&nbsp;&nbsp;
                                <span *ngIf="sentTopics.attachmentExists == 'Y'"><i class="fa fa-paperclip"></i></span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <span style="font-weight: 575; font-size: 10px; color: gold;">
                            Initiated By:&nbsp;{{sentTopics.createdByUser}}</span>
                        <span *ngIf="sentTopics.status == 'Closed'" style="float: right; color: red;">
                            <i class="fa fa-lock"></i> Closed</span>
                    </div>
                    <div class="module-content-leftpanel" *ngIf="sentTopics.moduleName">
                        <span>
                            {{sentTopics.moduleName}}&nbsp;-&nbsp;{{sentTopics.taskId}}&nbsp;-&nbsp;{{sentTopics.taskName}}<span
                                *ngIf="sentTopics.subTaskType">({{sentTopics.subTaskType}})</span>&nbsp;&nbsp;<span
                                *ngIf="sentTopics.version">&nbsp;&nbsp;V:&nbsp;&nbsp;{{sentTopics.version}}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-9 topic-right-section">

            <div class="col-md-11" *ngIf="showMessageContent && newMail">
                <div class="subjectTitle">{{latestTopicData.subject}}</div>
            </div>

            <div class="reply-btns-container">
                <ng-container *ngIf="replyMail || replyAllMail || forwardMail">
                    <span class="topic-btns edit-mode" (click)="discard()" matTooltip="Discard">
                        <i class="fa fa-trash"></i>&nbsp;&nbsp;Discard
                    </span>
                    <span class="topic-btns edit-mode"
                        (click)="openCommunicationPopup(replyMail ? 'Reply' : (replyAllMail ? 'ReplyAll' : 'Forward'))"
                        matTooltip="Pop Out">
                        <i class="fa-solid fa-up-right-from-square"></i>&nbsp;&nbsp;Pop Out
                    </span>
                </ng-container>
            </div>

            <div class="row message-body" *ngIf="!showMessageContent">
                <div class="emptyContentBody">
                    <div>Click any of the messages to view </div>
                </div>
            </div>

            <div class="row message-body" *ngIf="showMessageContent">
                <div *ngIf="newMail">
                    <div class="row" *ngIf="showButtons">
                        <div class="col-md-6">
                            <img src="../../assets/img/Group.png" width="35px" height="35px" alt="user-img" />
                            <span style="font-weight: bold;">
                                {{latestTopicData.fromUserName}}
                            </span>
                        </div>
                        <div class="col-md-6 emailMenus">
                            <span class="topic-btns view-mode" (click)="openDiv('Reply')" matTooltip="Reply">
                                <i class="fa fa-reply"></i>&nbsp;&nbsp;Reply
                            </span>
                            <span class="topic-btns view-mode" (click)="openDiv('ReplyAll')" matTooltip="Reply All">
                                <i class="fa-solid fa-reply-all"></i>&nbsp;&nbsp;ReplyAll
                            </span>
                            <span class="topic-btns view-mode" (click)="openDiv('Forward')" matTooltip="Forward">
                                <i class="fa fa-arrow-right"></i>&nbsp;&nbsp;Forward
                            </span>
                        </div>
                    </div>
                    <br>
                    <div class="row" style="margin-left: -2%;">
                        <div class="form-group">
                            <span class="bold-labels">To</span>&nbsp;&nbsp;
                            <span class="fontstyle">{{latestTopicData.toUserNames}}</span>
                        </div>
                    </div>
                    <div class="row" style="margin-left: -2%;" *ngIf="latestTopicData.ccUserNames">
                        <div class="form-group">
                            <span class="bold-labels">Cc</span>&nbsp;&nbsp;
                            <span class="fontstyle">{{latestTopicData.ccUserNames}}</span>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 1%;" *ngIf="latestTopicData.attachments.length>0">
                        <div class="row" style="margin-top: 1%;">
                            <div class="form-group">
                                <span class="bold-labels">
                                    <i class="fa fa-paperclip">&nbsp;
                                        <i class="attach-text">Attachment(s)</i>
                                    </i>
                                </span>&nbsp;&nbsp;
                                <span class="download-button" *ngFor="let file of latestTopicData.attachments;">
                                    <img [src]="getImageWhileDisplay(file)" alt="img" class="file-icon" width="20"
                                        height="20" />
                                    <span (click)="downloadDocument(file, latestTopicData)"
                                        matTooltip="Click to download">
                                        {{file}}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="replyMail||replyAllMail||forwardMail">
                    <div class="row replybody">
                        <div class="row">
                            <div class="col-md-1 d-flex justify-content-center align-items-center">
                                <div (click)="createTopic(communicationData)">
                                    <div class="send-btn-container">
                                        <i class="fa fa-send-o send-icon"></i>
                                        <div class="send-btn-text">Send</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-11">
                                <div class="row" style="margin-bottom: 2%;">
                                    <div class="col-md-1">
                                        <div class="to-cc-label">
                                            To
                                        </div>
                                    </div>
                                    <div class="col-md-11">
                                        <div class="row">
                                            <div id="toUserNames" class="col-md-11 users-container">
                                                <div class="file-list form-group">
                                                    <span class="user-name"
                                                        *ngFor="let toUser of toUsersArray; let i = index">
                                                        {{toUser.toUserName}}&nbsp;&nbsp;
                                                        <button class="remove-file-button" (click)="onToUserRemoved(i)"
                                                            matTooltip="Remove User">✕</button></span>
                                                </div>
                                            </div>
                                            <div class="col-md-1 search-icon" (click)="openSearchUserPopup('ToUser')">
                                                <i class="fa fa-search"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="margin-bottom: 2%;">
                                    <div class="col-md-1">
                                        <div class="to-cc-label">
                                            Cc
                                        </div>
                                    </div>
                                    <div class="col-md-11">
                                        <div class="row">
                                            <div id="ccUserNames" class="col-md-11 users-container">
                                                <div class="file-list">
                                                    <span class="user-name"
                                                        *ngFor="let ccUser of ccUsersArray; let i = index">
                                                        {{ccUser.ccUserName}}&nbsp;&nbsp;
                                                        <button class="remove-file-button" (click)="onCcUserRemoved(i)"
                                                            matTooltip="Remove User">✕</button></span>
                                                </div>
                                            </div>
                                            <div class="col-md-1 search-icon">
                                                <i class="fa fa-search" (click)="openSearchUserPopup('CcUser')"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-1">
                                        <div>
                                            Subject
                                        </div>
                                    </div>
                                    <div class="col-md-10">
                                        <input id="subject" class="underlined-input-box" type="text" autocomplete="off"
                                            [(ngModel)]="communicationData.subject">
                                    </div>
                                    <div class="col-md-1">
                                        <button class="choose-file-btn" (click)="openFileDialog()">
                                            <i class="fa fa-paperclip">
                                                &nbsp;<i class="attach-text">Attach</i>
                                            </i>
                                        </button>
                                        <input type="file" #fileInput style="display: none;"
                                            (change)="onFileSelected($event)" multiple />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="selectedFiles.length > 0" class="row" style="margin-top: 1%;">
                            <div class="col-md-12 file-container">
                                <p>Selected Files:</p>
                                <div class="file-list form-group">
                                    <span class="file-name" *ngFor="let file of selectedFiles; let i = index">
                                        <img [src]="getImageWhileSelection(file)" alt="img" class="file-icon" width="20"
                                            height="20" /> {{file.name}}&nbsp;&nbsp;
                                        <button class="remove-file-button" (click)="onFileRemoved(i)"
                                            matTooltip="Remove File">✕</button></span>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-left: 0px;margin-top: 10px;">
                            <div class="col-md-12">
                                <st-editor [(ngModel)]="communicationData.content" class="input-filed-continers"
                                    [config]="editorConfiguration"></st-editor>
                            </div>
                        </div>
                        <div class="old-messages">
                            <div>
                                <span class="bold-labels">From:&nbsp;&nbsp;</span>
                                <span class="fontstyle">{{latestTopicData.fromUserName}}</span>
                            </div>
                            <div>
                                <span class="bold-labels">Sent:&nbsp;&nbsp;</span>
                                <span class="fontstyle">
                                    {{latestTopicData.createdOn | date: 'dd-MMM-yyyy HH:mm'}}</span>
                            </div>
                            <div>
                                <span class="bold-labels">To:&nbsp;&nbsp;</span>
                                <span class="fontstyle">{{latestTopicData.toUserNames}}</span>
                            </div>
                            <div *ngIf="latestTopicData.ccUserNames">
                                <span class="bold-labels">Cc:&nbsp;&nbsp;</span>
                                <span class="fontstyle">{{latestTopicData.ccUserNames}}</span>
                            </div>
                            <div>
                                <span class="bold-labels">Subject:&nbsp;&nbsp;</span>
                                <span class="fontstyle">{{latestTopicData.subject}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" style="margin-left: 0px;margin-top: 10px;"
                    *ngIf="newMail||replyMail||replyAllMail||forwardMail">
                    <div class="col-md-12">
                        <st-editor id="content view-msg" style="max-height: fit-content !important;"
                            [(ngModel)]="latestTopicData.content" class="input-filed-continers"
                            [config]="config"></st-editor>
                    </div>
                </div>

                <div *ngIf="newMail||replyMail||replyAllMail||forwardMail">
                    <div class="old-messages" *ngFor="let topics of topicsData">
                        <div>
                            <div>
                                <span class="bold-labels">From:&nbsp;&nbsp;</span>
                                <span class="fontstyle">{{topics.fromUserName}}</span>
                            </div>
                            <div>
                                <span class="bold-labels">Sent:&nbsp;&nbsp;</span>
                                <span class="fontstyle">{{topics.createdOn | date: 'dd-MMM-yyyy HH:mm'}}</span>
                            </div>
                            <div>
                                <span class="bold-labels">To:&nbsp;&nbsp;</span>
                                <span class="fontstyle">{{topics.toUserNames}}</span>
                            </div>
                            <div *ngIf="topics.ccUserNames">
                                <span class="bold-labels">Cc:&nbsp;&nbsp;</span>
                                <span class="fontstyle">{{topics.ccUserNames}}</span>
                            </div>
                            <div>
                                <span class="bold-labels">Subject:&nbsp;&nbsp;</span>
                                <span class="fontstyle">{{topics.subject}}</span>
                            </div>
                            <div style="margin-top: 1%;" *ngIf="topics.attachments.length > 0">
                                <div class="row">
                                    <div class="form-group" style="line-height: 2.4;">
                                        <span class="bold-labels"><i class="fa fa-paperclip"> <span
                                                    class="reload_text">Attachments</span></i></span>&nbsp;&nbsp;
                                        <span class="download-button" *ngFor="let file of topics.attachments">
                                            <img [src]="getImageWhileDisplay(file)" alt="img" class="file-icon"
                                                width="20" height="20" />
                                            <span (click)="downloadDocument(file, topics)"
                                                matTooltip="Click to download">
                                                {{ file}}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top: 1%;">
                                <div class="col-md-12">
                                    <st-editor id="view-msg" [(ngModel)]="topics.content" class="input-filed-continers"
                                        [config]="config"></st-editor>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<mat-menu #contextMenu="matMenu">
    <ng-template matMenuContent let-item="item">
        <button *ngFor="let button of item" mat-menu-item style="font-size: 14px;min-height: 30px;"
            (click)="rightClickOperations(button)">
            <span class="rightClick"><span class={{button.icons}}></span>&nbsp;&nbsp;{{button.text}}</span>
        </button>
    </ng-template>
</mat-menu>

<ng-template #communicationPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" mat-button (click)="cancelCommunicationPopup()"><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle">{{popupData.title}}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="popup-mail-body">
        <div class="send-topics-firstrow">
            <div class="row">
                <div class="col-md-1 d-flex justify-content-center align-items-center">
                    <div>
                        <div class="send-btn-container" (click)="createTopic(communicationData)">
                            <i class="fa fa-send-o send-icon"></i>
                            <div class="send-btn-text">Send</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-11">
                    <div class="row" style="margin-bottom: 2%;">
                        <div class="col-md-1">
                            <div class="to-cc-label">
                                To
                            </div>
                        </div>
                        <div id="toUserNames" class="col-md-10 users-container">
                            <div class="file-list form-group">
                                <span class="user-name" *ngFor="let toUser of toUsersArray; let i = index">
                                    {{toUser.toUserName}}&nbsp;&nbsp;
                                    <button class="remove-file-button" (click)="onToUserRemoved(i)"
                                        matTooltip="Remove User">✕</button></span>
                            </div>
                        </div>
                        <div class="col-md-1">
                            <span class="search-user" (click)="openSearchUserPopup('ToUser')">
                                <img src="../../assets/img/search-user.svg" width="34px" height="34px" alt="add new" />
                            </span>
                        </div>
                    </div>
                    <div class="row" style="margin-bottom: 2%;">
                        <div class="col-md-1">
                            <div class="to-cc-label">
                                Cc
                            </div>
                        </div>
                        <div id="ccUserNames" class="col-md-10 users-container">
                            <div class="file-list form-group">
                                <span class="user-name" *ngFor="let ccUser of ccUsersArray; let i = index">
                                    {{ccUser.ccUserName}}&nbsp;&nbsp;
                                    <button class="remove-file-button" (click)="onCcUserRemoved(i)"
                                        matTooltip="Remove User">✕</button></span>
                            </div>
                        </div>
                        <div class="col-md-1">
                            <span class="search-user" (click)="openSearchUserPopup('CcUser')"><img
                                    src="../../assets/img/search-user.svg" width="34px" height="34px"
                                    alt="add new" /></span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-1">
                            <div>
                                Subject
                            </div>
                        </div>
                        <div class="col-md-10">
                            <input id="subject" class="underlined-input-box" type="text" autocomplete="off"
                                [(ngModel)]="communicationData.subject">
                        </div>
                        <div class="col-md-1">
                            <button class="choose-file-btn" (click)="openFileDialog()">
                                <i class="fa fa-paperclip">&nbsp;
                                    <i class="attach-text">Attach</i>
                                </i>
                            </button>
                            <input type="file" #fileInput style="display: none;" (change)="onFileSelected($event)"
                                multiple />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="selectedFiles.length > 0" class="row">
            <div class="col-md-12 file-container">
                <p>Selected Files:</p>
                <div class="file-list form-group">
                    <span class="file-name" *ngFor="let file of selectedFiles; let i = index">
                        <img [src]="getImageWhileSelection(file)" alt="img" class="file-icon" width="20" height="20" />
                        {{file.name}}&nbsp;&nbsp;
                        <button class="remove-file-button" (click)="onFileRemoved(i)"
                            matTooltip="Remove File">✕</button></span>
                </div>
            </div>
        </div>
        <div class="row" style="margin-left: 0px;margin-top: 10px;">
            <div class="col-md-12">
                <st-editor id="content str" style="background-color: red !important"
                    [(ngModel)]="communicationData.content" [config]="editorConfiguration"></st-editor>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #searchUserPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeSearchPopup()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> Search User(s)</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="search-popup">
        <div class="row" *ngIf="showCriteriaOptions">
            <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedUserCriteria">
                <mat-radio-button class="tp-radio-button" color="primary" *ngFor="let criteria of searchCriteriaOptions"
                    [value]="criteria" (change)="onSearchCriteriaChanged()">
                    {{criteria}}
                </mat-radio-button>
            </mat-radio-group>
        </div><br />

        <div class="row">
            <div class="col-md-4">
                <div><label for="email">User Name</label></div>
                <input class="search-filed-continers" type="text" [(ngModel)]="searchByUserName">
            </div>
            <div class="col-md-4" *ngIf="selectedUserCriteria == 'All Users'">
                <div><label for="email">First Name</label></div>
                <input class="search-filed-continers" type="text" [(ngModel)]="searchByFirstName">
            </div>
            <div class="col-md-4" *ngIf="selectedUserCriteria == 'All Users'">
                <div><label for="email">Last Name</label></div>
                <input class="search-filed-continers" type="text" [(ngModel)]="searchByLastName">
            </div>
            <div class="col-md-4" *ngIf="selectedUserCriteria == 'All Users'">
                <div><label for="email">Email</label></div>
                <input class="search-filed-continers" type="email" [(ngModel)]="searchByEmail">
                <div id="email-val-icon" class="field-icon-container"></div>
            </div>
            <div class="col-md-4" *ngIf="selectedUserCriteria == 'All Users'">
                <div><label for="email">Designation</label></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode"
                    (closed)="designationSearchText=''" (click)="focusSearch('focus-designation-search')">
                    <input type="search" id="focus-designation-search" class="dropdownsearchstyle"
                        [(ngModel)]="designationSearchText" matInput placeholder="search">
                    <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
                    <mat-option *ngFor="let item of designationListDropdown | assessmentSearch : designationSearchText"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-md-4" *ngIf="selectedUserCriteria == 'All Users'">
                <div><label for="email">Department</label></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode"
                    (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')">
                    <input type="search" id="focus-department-search" class="dropdownsearchstyle"
                        [(ngModel)]="departmentSearchText" matInput placeholder="search">
                    <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
                    <mat-option *ngFor="let item of departmentListDropdown | assessmentSearch : departmentSearchText"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
        </div>
        <div class="row">
            <div class="button-continer btn-align" mat-dialog-actions>
                <button mat-stroked-button class="addButton" (click)="searchUser()">
                    <i class="fa-solid fa-magnifying-glass"></i> Search
                </button>
                <button mat-stroked-button class="cancelButton" *ngIf="!users.length" (click)="closeSearchPopup()">
                    <i class="fa fa-close"></i> Cancel
                </button>
                <button mat-stroked-button class="cancelButton"
                    *ngIf="searchByUserName || searchByFirstName || searchByLastName || searchByEmail || searchByDesignationCode || searchByDepartmentCode || users.length"
                    (click)="reset()">
                    <i class="fas fa-undo"></i> Reset
                </button>
            </div>
        </div>
        <div class="table-container" *ngIf="users.length">
            <table style="max-height: 45vh;">
                <thead>
                    <th style="min-width: 60px; text-align: center;">
                        <div style="display: flex;">
                            <div>
                                <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                            <div style="margin-left: 5px;">
                                <input type="checkbox" style="zoom: 1.2;" [(ngModel)]="searchUserParentCheckBox"
                                    (change)="onParentCheckBoxChanged($event)">
                            </div>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>User Name</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>First Name</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Last Name</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Email</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Designation</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Department</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Manager Name</span>
                        </div>
                    </th>

                    <th id="menu" class="sticky-col first-col"></th>
                </thead>
                <tbody>
                    <tr class="data-row-container" *ngFor="let user of users; let idx = index;">
                        <td style="min-width: 80px; text-align: center;">
                            <div style="display: flex;">
                                <div [ngClass]="user.searchUserChildCheckBox ?'static_icon':'hover-menu-icons'">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                                <div style="margin-left: 5px;">
                                    <input id="selectedUserCheckBox`" type="checkbox" style="zoom: 1.2;"
                                        [checked]="user.searchUserChildCheckBox"
                                        (change)="onChildCheckBoxChanged($event, user, idx)">
                                </div>
                            </div>
                        </td>
                        <td class="row-data">{{ user.userName }}</td>
                        <td class="row-data">{{ user.firstName }}</td>
                        <td class="row-data">{{ user.lastName }}</td>
                        <td class="row-data">{{ user.emailAddress }}</td>
                        <td class="row-data">{{ user.designation }}</td>
                        <td class="row-data">{{ user.department }}</td>
                        <td class="row-data">{{ user.managerName }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions *ngIf="users.length">
            <button mat-stroked-button class="addButton" (click)="getUsers()"
                [disabled]="(dealingWith == 'ToUser' && tempToUsersArray.length < 1) || (dealingWith == 'CcUser' && tempCcUsersArray.length < 1)">
                <i class="fas fa-check"></i> Add
            </button>
            <button mat-stroked-button class="cancelButton" (click)="closeSearchPopup()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>